import React from 'react';
import style from './InlineBlock.scss';

const InlineBlock = ({ children }) => {
  // If Children is not array
  if (!children.length) {
    return (
      <div className={style.flex}>
        <div className={style.box}> {children} </div>
      </div>
    );
  }

  const maxWidth = 90 / children.length;
  const formatChildren = children.map(child => (
    <div className={style.box} key={child.props.name} style={{ maxWidth: `${maxWidth}%` }}>
      {child}
    </div>
  ));

  return <div className={style.flex}>{formatChildren}</div>;
};

export default InlineBlock;
